<template src='./issue-report.html'/>

<script>
import ContextPage from '@/components/context-page/ContextPage'
import Vue from 'vue'
import FileSaver from 'file-saver'
import { validationMixin } from '@/mixins/validation'
import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(DatetimePicker)

export default {
  mixins: [validationMixin],
  components: {
    ContextPage
  },
  computed: {
    formattedFilterFromDate () {
      if (!this.filter.from) {
        return null
      }
      return this.formatDate(this.filter.from)
    },
    formattedFilterToDate () {
      if (!this.filter.to) {
        return null
      }
      return this.formatDate(this.filter.to)
    }
  },
  data () {
    return {
      menuDatePickerFrom: false,
      menuDatePickerTo: false,
      filter: {
        from: null,
        to: null
      },
      loading: false
    }
  },
  methods: {
    excelReport () {
      this.loading = true
      this.$http.post(Vue.$apiConfig.issueCumulativeReportPost, this.filter, { responseType: 'blob' })
        .then(response => {
          this.loading = false
          var headers = response.headers
          var blob = new Blob([response.data], { type: headers['content-type'] })
          FileSaver.saveAs(blob, this.$t('reports.issue') + ' ' + this.formatShortDate(new Date()) + 'xlsx')
        },
        error => {
          this.loading = false
          this.logConsole(error)
          this.formatErrorResponse(error)
        })
    }
  }
}
</script>
